
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/nguoi-dung",
      function () {
        return require("private-next-pages/admin/nguoi-dung/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/nguoi-dung"])
      });
    }
  